import * as types from '../constants/actionTypes';

const initialState = {
    filterModels: {}
};

export default function reportsReducer(state = initialState, action) {
    switch(action.type) {
        case types.SAVE_REPORT_FILTER_VALUES: {
            if (!action || !action.payload || !action.payload.reportId) {
                return state;
            }

            const reportId = action.payload.reportId.toString();
            const formValues = action.payload.filterValues;
            
            return {
                ...state,
                filterModels: {
                    ...state.filterModels,
                    [reportId]: formValues
                }
            };
        }
        default:
            return state;
    }
}
